import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import {
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Col,
  Container,
  Row,
  UncontrolledAccordion,
} from "reactstrap"

const Faq = () => {
  const data = useStaticQuery(graphql`
    {
      markdownRemark(frontmatter: { contentKey: { eq: "academyPage" } }) {
        frontmatter {
          frequently_asked_questions {
            faq_heading
            faq_question_answer_pair {
              faq_question
              faq_answer
            }
          }
        }
      }
    }
  `)

  const { faq_heading, faq_question_answer_pair } =
    data.markdownRemark.frontmatter.frequently_asked_questions

  console.log(faq_question_answer_pair)

  return (
    <>
      <Container className="mt-100 mt-60">
        <Row className="align-items-center justify-content-center">
          <Col md="10" xs="11" className="mt-4 mt-sm-0 pt-2 pt-sm-0">
            <div className="section-title mb-4 pb-2">
              <h4 className="title mb-2 text-center">{faq_heading}</h4>
            </div>

            <div>
              <UncontrolledAccordion flush>
                {faq_question_answer_pair.map((faq, index) => {
                  return (
                    <AccordionItem key={index}>
                      <AccordionHeader targetId={index}>
                        {faq.faq_question}
                      </AccordionHeader>
                      <AccordionBody accordionId={index}>
                        {faq.faq_answer}
                      </AccordionBody>
                    </AccordionItem>
                  )
                })}
              </UncontrolledAccordion>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Faq
